<template>
  <div class="ViewPointSet">
    <div class="baseInfo">
      <div class="title">
        <span class="line"></span>
        <span>基本信息</span>
      </div>
      <el-form :model="viewInfo" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
        <div class="label" style="color: rgba(255, 255, 255, 0.3);;font-size: 13px">{{viewType===1?'视点名称':'动画名称'}}</div>
        <el-form-item prop="name">
          <el-input v-model.trim="viewInfo.name" placeholder="请输入内容" :maxlength="20" show-word-limit @change="onValueChange"></el-input>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="title">
        <span class="line"></span>
        <span>常用设置</span>
      </div>
      <div class="form-item">
        <div class="label">{{viewType===1?'设为默认视角':'设为默认动画'}}</div>
        <el-switch
            v-model="viewInfo.defaulted"
            active-color="#00A4F0"
            inactive-color="#494B4D"
            @change="onValueChange">
        </el-switch>
      </div>
      <div class="form-item">
        <div class="label">{{viewType===1?'设为常用视角':'设为常用动画'}}</div>
        <el-switch
            v-model="viewInfo.frequently"
            active-color="#00A4F0"
            inactive-color="#494B4D"
            @change="onValueChange">
        </el-switch>
      </div>
    </div>
    <div class="point-set" v-if="viewType===2">
      <div class="title">
        <span class="line"></span>
        <span>视点</span>
      </div>
      <div class="create-point">
        <el-select v-model.lazy="selectedPoint" placeholder="选择视点" @change="onAddSelectedPointItem" class="set-item1">
          <el-option
            v-for="item in pointsList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.disabled">
          </el-option>
        </el-select>
        <el-input v-model.lazy="totalTime" placeholder="总时长" type="number" :min="0" :max="2000" oninput="value=value.replace(/[^\d]/g,'0')"  @change="onChangeTotalTime"  class="set-item2">
          <template slot="suffix">s</template>
        </el-input>
        <Icon type="big" class="set-icon" name="icon-camera" content="创建视点" @click.native="onCreateAnimationPoint"></Icon>
      </div>
      <div class="point-list">
        <transition-group name="drag" tag="div">
          <div class="point-item" v-for="(item, i) in viewInfo.viewpoints" :key="item.viewpoint.view.coverUrl" draggable="true" @dragenter="dragenter($event, i)"  @dragover="dragover($event, i)" @dragstart="dragstart(i)">
            <el-image class="set-item3" :src="item.viewpoint.view.coverUrl" fit="cover">
              <div slot="placeholder" class="image-slot">
                <img src="~@/assets/images/logo2.png">
              </div>
            </el-image>
            <div class="top-tag">{{i+1}}</div>
            <el-input v-model.trim="item.viewpoint.name" placeholder="名称" :maxlength="20" :disabled="item.disabled" @change="onValueChange"  class="set-item4"></el-input>
            <el-input v-model.number.lazy="item.duration" maxlength="2" oninput="value=value.replace(/[^\d]/g,'0')" placeholder="时长" @change="(value)=>{onDurationChange(value, item)}"  class="set-item2">
              <template slot="suffix">s</template>
            </el-input>
            <Icon type="big" class="set-icon icon-reduce" name="icon-reduce" content="删除视点" @click="removePoint(i)"></Icon>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneObject, dataToFile, dateFtt } from '@/utils/util'
import { getViewAnimation } from '@/api/viewer'
import { uploadOss } from '@/api/system'
export default {
  name: 'ViewPointSet',
  props: {
    pointsList: {
      type: Array,
      default: () => { return [] }
    },
    animationsList: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      // 样式属性
      viewInfo: {
        'defaulted': false,
        'frequently': false,
        'name': ''
      },
      totalTime: 0,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入1~20个字符', trigger: 'blur' }
        ]
      },
      // 保存的原始信息
      originInfo: undefined,
      tableName: undefined,

      viewType: 1,
      selectedPoint: undefined,
      // pointsList: [],
      dragIndex: undefined
    }
  },
  watch: {
    viewInfo: {
      deep: true,
      handler: function (val) {
        this.totalTime = this.getTotalTime()
      }
    },
    pointsList: {
      deep: true,
      handler: function (val) {
        if (val && val.length > 0) {
          this.updatePointState()
        }
      }
    }
  },
  mounted () {
    // this.getViewPointsList()
  },
  methods: {
    async setData (data, type) {
      this.viewType = type
      if (this.viewType === 1) {
        if (!data) {
          this.viewInfo = await this.createViewPoint()
          this.setOrigin({})
          this.$emit('viewChanged', this.viewInfo)
          this.$emit('createPoint', this.viewInfo)
        } else {
          this.$cesiumPlus.cameraManager.flyTo({
            position: data.view.cameraPosition,
            direction: [data.view.cameraHeading, data.view.cameraPitch, data.view.cameraRoll]
          })
          this.setOrigin(data)
          this.viewInfo = data
        }
      } else if (this.viewType === 2) {
        if (!data) {
          this.viewInfo = this.createAnimation()
          this.updatePointState()
          this.setOrigin({})
          this.$emit('viewChanged', this.viewInfo)
          this.$emit('createPoint', this.viewInfo)
        } else {
          this.setOrigin(data)
          this.viewInfo = data
          this.getViewAnimation()
        }
      }
    },
    // 获取视点默认名称
    getPointDefaultName () {
      let index = 1
      while (true) {
        const findres = this.pointsList.findIndex(item => {
          return item.name === `视点${index}`
        })
        if (findres < 0) {
          return `视点${index}`
        }
        index += 1
      }
    },
    // 获取动画默认名称
    getAnimationDefaultName () {
      let index = 1
      while (true) {
        const findres = this.animationsList.findIndex(item => {
          return item.name === `动画${index}`
        })
        if (findres < 0) {
          return `动画${index}`
        }
        index += 1
      }
    },
    // 创建视点
    async createViewPoint () {
      const base64Img = this.$cesiumPlus.utils.screenCapture(this.$cesiumPlus.viewer.canvas)
      const imgName = '截图' + dateFtt('yyyyMMddhhmmss', new Date()) + '.jpg'
      const file = dataToFile(base64Img, imgName)
      const res = await uploadOss(file)
      // if (!res || !res.url) {
      //   return
      // }
      // debugger
      let viewName = '视点' + dateFtt('yyyyMMddhhmmss', new Date())
      if (this.viewInfo.viewpoints) {
        viewName = '视点' + (this.viewInfo.viewpoints.length + 1)
      } else {
        viewName = this.getPointDefaultName()
      }

      const curPos = this.$cesiumPlus.cameraManager.getCameraPosition()
      const curDir = this.$cesiumPlus.cameraManager.getCameraDirection()
      const data = {
        'defaulted': false,
        'frequently': false,
        'mapId': this.$route.query.mapId,
        'name': viewName,
        'view': {
          'cameraHeading': curDir[0],
          'cameraPitch': curDir[1],
          'cameraPosition': curPos,
          'cameraRoll': curDir[2],
          'coverUrl': res.url
        }
      }
      return data
    },
    // 创建动画
    createAnimation () {
      // const animationName = '动画' + dateFtt('yyyyMMddhhmmss', new Date())
      const animationName = this.getAnimationDefaultName()
      const data = {
        'coverUrl': '',
        'defaulted': false,
        'frequently': false,
        'mapId': this.$route.query.mapId,
        'name': animationName,
        'viewpoints': []
      }
      return data
    },
    // 获取动画的视点列表
    getViewAnimation () {
      if (!this.viewInfo.id) {
        this.updatePointState()
        return
      }
      getViewAnimation({
        id: this.viewInfo.id
      }).then(res => {
        if (res.code === 200) {
          // this.framesList = res.data.viewpoints
          this.$set(this.viewInfo, 'viewpoints', res.data.viewpoints)
          // this.getViewPointsList()
          if (res.data.viewpoints.length > 0) {
            const item = res.data.viewpoints[0]
            this.$cesiumPlus.cameraManager.flyTo({
              position: item.viewpoint.view.cameraPosition,
              direction: [item.viewpoint.view.cameraHeading, item.viewpoint.view.cameraPitch, item.viewpoint.view.cameraRoll]
            })
          }
          this.updatePointState()
        }
      })
    },
    // 获取视点列表
    // getViewPointsList () {
    //   getViewPointList({
    //     mapId: this.$route.query.mapId
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.pointsList = res.data
    //       this.updatePointState()
    //     }
    //   })
    // },
    // 还原数据
    resetData () {
      cloneObject(this.originInfo, this.viewInfo)
      // this.viewInfo = JSON.parse(JSON.stringify(this.originInfo))
    },
    // 设置原始数据
    setOrigin (data) {
      this.originInfo = JSON.parse(JSON.stringify(data))
    },
    // 属性值修改
    onValueChange () {
      // if (this.viewInfo.name) {
      //   this.$emit('viewChanged', this.viewInfo)
      // }
      this.$emit('viewChanged', this.viewInfo)
    },
    // 获取总时长
    getTotalTime () {
      let time = 0
      if (!this.viewInfo || !this.viewInfo.viewpoints) {
        return time
      }
      for (let i = 0; i < this.viewInfo.viewpoints.length; i++) {
        if (!this.viewInfo.viewpoints[i].duration) {
          this.viewInfo.viewpoints[i].duration = 0
        }
        time += this.viewInfo.viewpoints[i].duration
      }
      return time
    },
    onChangeTotalTime (val) {
      if (!this.viewInfo || this.viewInfo.viewpoints.length <= 0) {
        return
      }
      if (val > 2000) {
        this.$Message('warning', '总时长不能超过2000 S')
        this.totalTime = this.getTotalTime()
        return
      }
      if (this.totalTime % this.viewInfo.viewpoints.length !== 0) {
        this.$Message('warning', `请输入${this.viewInfo.viewpoints.length}的倍数`)
        this.totalTime = this.getTotalTime()
        return
      }
      const duration = this.totalTime / this.viewInfo.viewpoints.length
      for (let i = 0; i < this.viewInfo.viewpoints.length; i++) {
        this.viewInfo.viewpoints[i].duration = duration
      }
      this.$emit('viewChanged', this.viewInfo)
    },
    onDurationChange (val, item) {
      this.totalTime = this.getTotalTime()
      if (this.totalTime > 2000) {
        this.$Message('warning', '总时长不能超过2000 S')
        item.duration = 0
      }
    },
    // 清除数据
    clear () {
      this.viewInfo = {
        name: undefined,
        tableId: undefined,
        type: undefined
      }
      this.tableName = undefined
    },
    // 拖拽响应事件
    dragstart (index) {
      this.dragIndex = index
    },
    dragenter (e, index) {
      e.preventDefault()
      if (this.dragIndex !== index) {
        const moving = this.viewInfo.viewpoints[this.dragIndex]
        this.viewInfo.viewpoints.splice(this.dragIndex, 1)
        this.viewInfo.viewpoints.splice(index, 0, moving)
        this.dragIndex = index
      }
    },
    dragover (e, index) {
      e.preventDefault()
      // this.isDraggable = false
      if (this.viewInfo.viewpoints.length > 0) {
        this.viewInfo.coverUrl = this.viewInfo.viewpoints[0].viewpoint.view.coverUrl
      }
      this.$emit('viewChanged', this.viewInfo)
    },
    // 创建动画视点
    async onCreateAnimationPoint () {
      if (this.viewInfo.viewpoints.length >= 20) {
        this.$Message('warning', '单个动画视点数量不能超过20')
        return
      }
      const point = await this.createViewPoint()
      const sort = this.viewInfo.viewpoints.length + 1
      this.viewInfo.viewpoints.push({
        'duration': 2,
        'sort': sort,
        'viewpoint': point
      })

      // this.$set(this.viewInfo.viewpoints, this.viewInfo.viewpoints.length, {
      //   'duration': 2,
      //   'sort': sort,
      //   'viewpoint': point
      // })
      if (this.viewInfo.viewpoints.length === 1) {
        this.viewInfo.coverUrl = point.view.coverUrl
      }
      this.$emit('viewChanged', this.viewInfo)
    },
    // 添加已有视点
    onAddSelectedPointItem (id) {
      let index = -1
      for (let i = 0; i < this.pointsList.length; i++) {
        if (this.pointsList[i].id === id) {
          const data = JSON.parse(JSON.stringify(this.pointsList[i]))
          const sort = this.viewInfo.viewpoints.length + 1
          this.viewInfo.viewpoints.push({
            'duration': 2,
            'sort': sort,
            'viewpoint': data
          })

          index = i
        }
      }
      if (this.viewInfo.viewpoints.length === 1) {
        this.viewInfo.coverUrl = this.pointsList[index].view.coverUrl
      }
      this.updatePointState()
      this.$emit('viewChanged', this.viewInfo)
      this.selectedPoint = undefined
    },
    // 删除视点
    removePoint (i) {
      this.viewInfo.viewpoints.splice(i, 1)
      this.updatePointState()
      // this.$Delete({
      //   confirm: () => {
      //     this.viewInfo.viewpoints.splice(i, 1)
      //     this.updatePointState()
      //   },
      //   cancel: () => {
      //   }
      // })
    },
    // 更新视点可用性
    updatePointState () {
      if (!this.viewInfo || !this.viewInfo.viewpoints) {
        return
      }
      for (let i = 0; i < this.pointsList.length; i++) {
        const item = this.pointsList[i]
        item.disabled = this.viewInfo.viewpoints.findIndex((value, index) => {
          if (value.viewpointId === item.id || value.viewpoint.id === item.id) {
            return true
          }
          return false
        }) >= 0
      }
      for (let i = 0; i < this.viewInfo.viewpoints.length; i++) {
        const item = this.viewInfo.viewpoints[i]
        item.disabled = this.pointsList.findIndex((value, index) => {
          if ((item.viewpointId && item.viewpointId === value.id) || (!item.viewpointId && item.viewpoint.id === value.id)) {
            return true
          }
          return false
        }) >= 0
      }
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .ViewPointSet{
    text-align: left;
    .demo-ruleForm{
      margin-bottom: 0px;
    }
    .divider{
      width: 260px;
      margin-left: -12px;
    }
    .title{
      color: #FFFFFF;
      font-size: 14px;
      margin-bottom: 15px;
      >.line{
        display: inline-block;
        margin-right: 4px;
        width: 3px;
        height: 10px;
        background: #00A4F0;
        border-radius: 2px;
      }
    }
    .el-input .el-input__inner{
      font-size: 12px !important;
    }
    .el-input__prefix{
      display: flex;
      align-items: center;
      padding-left: 10px;
      >img{
        width: 15px;
        height: 15px;
      }
    }
    .baseInfo{
      border-bottom: 1px solid #424345;
      padding: 16px 12px;
      box-sizing: border-box;
      padding-bottom: 0;
      .imgType{
        margin-bottom: 30px;
        >img{
          width: 60px;
          height: 60px;
          background: #373839;
          border-radius: 6px;
          margin-right: 26px;
          margin-bottom: 8px;
        }
      }
      .form-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        .label{
          width: 120px;
          font-size: 12px;
          color: #999999;
        }
      }
    }
    .point-set{
      border-bottom: 1px solid #424345;
      padding: 16px 0 12px 16px;
      box-sizing: border-box;
      padding-bottom: 0;
      .create-point{
        margin-bottom: 8px;
      }
      .set-item1{
        width: 139px;
        margin-right: 7px;
      }
      .set-item2{
        width: 64px;
        margin-right: 2px;
        &.el-input{
          .el-input__inner{
            padding-right: 15px !important;
          }
        }
      }
      .set-icon{
        margin-right: -20px;
        vertical-align: bottom;
        transform: scale(0.8);
        &.icon-reduce{
          &:hover{
            svg{
              color: #f00 !important;
            }
          }
        }
      }
      .point-list{
        height: 485px;
        overflow-y: overlay;
        .drag-move {
          transition: transform 0.3s;
        }
        .point-item{
          margin-bottom: 8px;
          .top-tag{
            position: relative;
            top: -9px;
            right: 62px;
            display: inline-block;
            width: 18px;
            height: 12px;
            background: linear-gradient(-39deg, #0C7EEB, #77B5F8);
            opacity: 0.8;
            border-radius: 6px 0px 6px 0px;
            text-align: center;
            margin-right: -16px;
            line-height: 12px;
          }
          .set-item3{
            width: 56px;
            height: 32px;
            border-radius: 6px;
            margin-right: 7px;
            vertical-align: bottom;
            pointer-events: none;
            .image-slot{
              text-align: center;
            }
          }
          .set-item4{
            width: 74px;
            margin-right: 7px;
          }
        }
      }
      input[type=number] {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        -moz-appearance: textfield;
      }
    }
  }
</style>
